import { Stack } from '@mui/material';

import clsx from 'clsx';

import ImageUploadButtonSkeleton from './ImageUploadButton/skeleton';
import InsertFormulaButtonSkeleton from './InsertFormulaButton/skeleton';
import TextFormattingButtonsSkeleton from './TextFormattingButtons/skeleton';
import { ToolbarCustomizationProps, ToolbarProps } from './types';

export interface ToolbarSkeletonProps extends ToolbarCustomizationProps, Pick<ToolbarProps, 'className' | 'classes'> {}

const ToolbarSkeleton = ({
  canFormatText,
  canInsertFormula,
  canUploadImage,
  children,
  className,
  classes,
}: ToolbarSkeletonProps) => {
  return (
    <Stack direction="row" alignItems="center" gap={2} p={2} className={clsx(className, classes?.root)}>
      {canFormatText && <TextFormattingButtonsSkeleton classes={classes} />}
      {canInsertFormula && <InsertFormulaButtonSkeleton classes={classes} />}
      {canUploadImage && <ImageUploadButtonSkeleton classes={classes} />}
      {children}
    </Stack>
  );
};

export default ToolbarSkeleton;
